import { DeviceState as DeviceStateEnum } from '@era/locations-sdk';
import { select, Store } from '@ngrx/store';
import { Device } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as DeviceStoreSelectors from '../../device-store/device.selector';
import { LocationSubset } from '../models/location-subset';

export function getDevicesFilteredOnSubset(store: Store, locationSubset: LocationSubset): Observable<Device[]> {
  switch (locationSubset) {
    case LocationSubset.All:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationDevices));
    case LocationSubset.Assigned:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationAssignedDevices));
    case LocationSubset.Spare:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationSpareDevices));
    case LocationSubset.Swapped:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationSwappedDevices));
    case LocationSubset.Housekeeping:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationHousekeepingDevices));
    case LocationSubset.Staff:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationStaffDevices));
    case LocationSubset.FrontDesk:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationFrontDeskDevices));
    case LocationSubset.Bar:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationBarDevices));
    case LocationSubset.Kiosk:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationKioskDevices));
  }
}

export function getDevicesCountFilteredOnSubset(store: Store, locationSubset: LocationSubset): Observable<number> {
  switch (locationSubset) {
    case LocationSubset.All:
      return store.pipe(
        select(DeviceStoreSelectors.selectCurrentLocationDevices),
        map((devices) => devices?.length ?? 0)
      );
    case LocationSubset.Assigned:
      return store.pipe(
        select(DeviceStoreSelectors.selectCurrentLocationDevicesCountByDeviceState(DeviceStateEnum.Assigned))
      );
    case LocationSubset.Spare:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationSpareDevicesCount));
    case LocationSubset.Swapped:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationSwappedDevicesCount));
    case LocationSubset.Housekeeping:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationHousekeepingDevicesCount));
    case LocationSubset.Staff:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationStaffDevicesCount));
    case LocationSubset.FrontDesk:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationFrontDeskDevicesCount));
    case LocationSubset.Bar:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationBarDevicesCount));
    case LocationSubset.Kiosk:
      return store.pipe(select(DeviceStoreSelectors.selectCurrentLocationKioskDevicesCount));
  }
}
